module.exports = __webpack_public_path__ + "img/vignettes-asso_0016_ares.482a6b53.jpg";